import React, { useEffect } from "react";
import './App.css';
import Header from './Header';
import Home from './Home';
import Checkout from './Checkout';
import Login from './Login';
import Payment from './Payment';
import Orders from './Orders';
import { BrowserRouter as Router,Switch,Route} from "react-router-dom";
import {auth} from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";

const promise = loadStripe('pk_test_51KS0anKyLhdcmJvVanZdYE6wt6qjW7QgVEoRHTUthoFLs2H9LiPNilbM0TXMkp0dxWijorJgSSsk4llWFq848c4200iImGwXwm');

function App() {

  const [{},dispatch]=useStateValue();

  useEffect(() => {
    auth.onAuthStateChanged(authUser => {
      console.log('THE USER IS >>>',authUser);

      if (authUser) {
        dispatch({
          type: 'SET_USER',
          user: authUser
        })
      } else {
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    })
  },[])

  return (
    // BEM
    <Router>
      <div className="app"> 
          
          <Switch>
            <Route path="/orders">
              <Header/>
              <Orders/>
            </Route>
          <Route path="/login">
              <Login/>
            </Route>

            <Route path="/checkout">
              <Header />
              <Checkout/>
            </Route>

            <Route path="/payment">
              <Header/>
              <Elements stripe={promise}>
                <Payment/>
              </Elements>
            </Route>

            <Route path="/">
              <Header />
              <Home/>
            </Route>

            
          </Switch>
      </div>
    </Router>
  );
}

export default App;
